// extracted by mini-css-extract-plugin
export default {"root":"dkcQmL2__zQMaj08lXKa","icon-button":"btV0YS7TFcQjR5Fiihed","search-icon":"lUXm1jIYIBac_YNuKwlx"};